import { render, staticRenderFns } from "./attached-file.vue?vue&type=template&id=c971ba2e&scoped=true"
import script from "./attached-file.vue?vue&type=script&lang=js"
export * from "./attached-file.vue?vue&type=script&lang=js"
import style0 from "./attached-file.vue?vue&type=style&index=0&id=c971ba2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c971ba2e",
  null
  
)

export default component.exports